import Model from "~/models/_Model";

export default class Course extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/courseplanner";
  }

  // Set the resource route of the model
  resource() {
    return "courses";
  }

  relations() {
    return {
      // students: Student
    };
  }

  // Computed Attributes
  get display_course() {
    return this.COURSE.trim();
  }

  get display_course_description() {
    return `${this.COURSE.trim()}: ${this.DESCRIPTION_CLEAN}`;
  }

  get is_core_graduation_requirement() {
    if (!this.core_grad_requirement) {
    }
    return false;
  }

  get display_block_type() {
    switch (this.BLOCK_TYPE) {
      case "B":
        return "Block";
      case "C":
        return "Blockette";
      case "N":
        return "Standalone";
    }
    return "Unknown Course Block Type";
  }

  get display_html_course_additional_info() {
    return (
      `<strong>Grade Level(s):</strong> ${this.grade_restrictions_description} | ` +
      `<strong>Weight:</strong> ${this.course_level_description}<br />` +
      (this.prerequisites != "None"
        ? `<strong>Prerequisites:</strong> ${this.prerequisites} | `
        : "") +
      `Uses <strong>${this.CREDIT}</strong>` +
      (this.CREDIT == 1 ? " Credit" : " Credits")
    );
  }
}
